<template>
  <span>
    <ViewBar :hidden="true"></ViewBar>
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12 class="text-center" mt-5>
          <h1>{{ $t('signup.label.signup') }}</h1>
        </v-flex>
        <v-flex xs12 sm6 offset-sm3 mt-3>
          <form @submit.prevent="signUp">
            <v-layout column>
              <v-flex>
                <v-alert type="error" dismissible v-model="alert">{{ error }}</v-alert>
              </v-flex>
              <v-flex>
                <v-text-field
                  name="email"
                  v-bind:label="$t('signup.label.email')"
                  id="signup_email"
                  type="email"
                  v-model="email"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  name="password"
                  v-bind:label="$t('signup.label.password')"
                  id="signup_password"
                  v-model="password"
                  required
                  :append-icon="passwd ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="passwd ? 'text' : 'password'"
                  @click:append="passwd = !passwd"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  name="confirmPassword"
                  v-bind:label="$t('signup.label.cpassword')"
                  id="signup_confirmPassword"
                  :rules="[rules.required, rules.min, rules.samePasswords]"
                  v-model="passwordConfirm"
                  required
                  :append-icon="cpasswd ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="cpasswd ? 'text' : 'password'"
                  @click:append="cpasswd = !cpasswd"
                ></v-text-field>
              </v-flex>
              <v-flex class="text-center" mt-5>
                <v-btn
                  color="primary"
                  type="submit"
                  :disabled="buttonDisabled"
                  id="btn_signup"
                >{{ $t('signup.button.signup') }}</v-btn>
              </v-flex>
            </v-layout>
          </form>
        </v-flex>
      </v-layout>
    </v-container>
  </span>
</template>

<script>
import ViewBar from "../components/viewbar/ViewBar";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  components: {
    ViewBar,
  },
  data() {
    return {
      email: "",
      password: "",
      passwordConfirm: "",
      passwd: false,
      cpasswd: false,
      rules: {
        samePasswords: v => v == this.password || this.$t('app.message.passwordsmustmatch'),
        required: v => !!v || this.$t('app.message.required'),
        min: v => v.length >= 4 || this.$t('app.message.minlengthpassword', {length: 4}),
      }
    };
  },
  computed: {
    ...mapMutations("auth", ["setError"]),
    ...mapState("auth", [ "error", "loading" ]),
    alert: {
      get() {
        return this.error != null;
      },
      set(value) {
        if (!value)
          this.setError(null)
      }
    },
    buttonDisabled() {
      return this.loading || this.password != this.passwordConfirm
    },
  },
  methods: {
    ...mapActions("auth", ["userSignUp"]),
    signUp() {
      this.userSignUp({email: this.email, password: this.password})
    }
  },
};
</script>
